import {useEffect, useState} from "react";
import _ from "lodash";

export function setBranchCategory(data, depth, category, branch, parent, parentsParent, parentsParentsParent) {
    if (depth === 1) {
        data[branch]["category"] = category
    }
    if (depth === 2) {
        data[parent][branch]["category"] = category
    }
    if (depth === 3) {
        data[parentsParent][parent][branch]["category"] = category
    }
    if (depth === 4) {
        data[parentsParentsParent][parentsParent][parent][branch]["category"] = category
    }
}

export function setBranchSupportType(data, depth, supporttype, branch, parent, parentsParent, parentsParentsParent) {
    if (depth === 1) {
        data[branch]["supporttype"] = supporttype
    }
    if (depth === 2) {
        data[parent][branch]["supporttype"] = supporttype
    }
    if (depth === 3) {
        data[parentsParent][parent][branch]["supporttype"] = supporttype
    }
    if (depth === 4) {
        data[parentsParentsParent][parentsParent][parent][branch]["supporttype"] = supporttype
    }
}

export function setSupportNeedStatus(hasSupportNeed, data, depth, branch, parent, parentsParent, parentsParentsParent, supporttype, followuptype) {
    if (hasSupportNeed) {
        if (depth === 1) {
            delete data[branch]["supportneed"]
            delete data[branch]["category"]
            delete data[branch]["supporttype"]
            delete data[branch]["followuptype"]
        }
        if (depth === 2) {
            delete data[parent][branch]["supportneed"]
            delete data[parent][branch]["category"]
            delete data[parent][branch]["supporttype"]
            delete data[parent][branch]["followuptype"]

        }
        if (depth === 3) {
            delete data[parentsParent][parent][branch]["supportneed"]
            delete data[parentsParent][parent][branch]["category"]
            delete data[parentsParent][parent][branch]["supporttype"]
            delete data[parentsParent][parent][branch]["followuptype"]
        }
        if (depth === 4) {
            delete data[parentsParentsParent][parentsParent][parent][branch]["supportneed"]
            delete data[parentsParentsParent][parentsParent][parent][branch]["category"]
            delete data[parentsParentsParent][parentsParent][parent][branch]["supporttype"]
            delete data[parentsParentsParent][parentsParent][parent][branch]["followuptype"]
        }
    } else {
        if (depth === 1) {
            data[branch]["supportneed"] = true
            data[branch]["category"] = branch.slice(6)
            data[branch]["supporttype"] = supporttype
            data[branch]["followuptype"] = followuptype
        }
        if (depth === 2) {
            data[parent][branch]["supportneed"] = true
            data[parent][branch]["category"] = branch.slice(6)
            data[parent][branch]["supporttype"] = supporttype
            data[parent][branch]["followuptype"] = followuptype
        }
        if (depth === 3) {
            data[parentsParent][parent][branch]["supportneed"] = true
            data[parentsParent][parent][branch]["category"] = branch.slice(6)
            data[parentsParent][parent][branch]["supporttype"] = supporttype
            data[parentsParent][parent][branch]["followuptype"] = followuptype
        }
        if (depth === 4) {
            data[parentsParentsParent][parentsParent][parent][branch]["supportneed"] = true
            data[parentsParentsParent][parentsParent][parent][branch]["category"] = branch.slice(6)
            data[parentsParentsParent][parentsParent][parent][branch]["supporttype"] = supporttype
            data[parentsParentsParent][parentsParent][parent][branch]["followuptype"] = followuptype
        }
    }   
}

export function nextBranchName(branches, parent) {
    let branchName
    const firstInBranch = branches.length < 1
    if (firstInBranch) {
        if (parent) {
            branchName = parent+"1"
        } else {
            branchName = "branchA"
        }
    } else {
        const endInNumberRegex = new RegExp(/\d+$/)
        const otherBranchesEndInNumber = branches.some(branch => endInNumberRegex.test(branch))
        if (otherBranchesEndInNumber) {
            // Check branches for highest number
            let endNumbers = []
            for (let i = 0; i < branches.length; i++ ) {
                const endNumber = branches[i].match(/\d+$/)
                if (endNumber) {
                    endNumbers.push(parseInt(endNumber[0], 10))
                }
            }
            const highestNumber = Math.max(...endNumbers)
            const lastBranch = branches.filter(branch => branch.endsWith(highestNumber))
            const endNumberLength = highestNumber.toString().length
            const lastBranchBody = lastBranch[0].slice(0, -endNumberLength)
            const nextNumber = highestNumber + 1
            branchName = lastBranchBody+nextNumber
        } else {
            const sortedBranches = branches.sort()
            let endLetters = []
            for (let i = 0; i < sortedBranches.length; i++ ) {
                // check branches for last letter
                const endLetter = sortedBranches[i].charAt(sortedBranches[i].length - 1)
                if (endLetter) {
                    endLetters.push(endLetter)
                }
            }
            const lastLetter = endLetters[endLetters.length - 1]
            const nextLetter = String.fromCharCode(lastLetter.charCodeAt(0)+1)
            const lastBranchBody = sortedBranches[sortedBranches.length - 1].slice(0, -1)
            branchName = lastBranchBody+nextLetter
        }
    }

    return branchName
}

export function getConditionForBranchName(branch) {
    const branchText = branch.slice(6)
    let conditionText = branchText.split('')
    for (let i = 0; i < branchText.length; i++) {
        // Check if number or letter
        conditionText[i] = /^\d+$/.test(branchText.charAt(i)) ? branchText.charAt(i) : branchText.charAt(i).toLowerCase()
    }
    const conditionTextString = conditionText.join('')
    const condition = "^"+conditionTextString+"\\b"
    return condition
}

export function changeBranchName(newKey, data, depth, branch, parent, parentsParent, parentsParentsParent) {
    const condition = getConditionForBranchName(newKey)
    if (depth === 1) {
        data[newKey] = data[branch]
        data[newKey]["condition"] = condition
        delete data[branch]
    }
    if (depth === 2) {
        data[parent][newKey] = data[parent][branch]
        data[parent][newKey]["condition"] = condition
        delete data[parent][branch]
    }
    if (depth === 3) {
        data[parentsParent][parent][newKey] = data[parentsParent][parent][branch]
        data[parentsParent][parent][newKey]["condition"] = condition
        delete data[parentsParent][parent][branch]
    }
    if (depth === 4) {
        data[parentsParentsParent][parentsParent][parent][newKey] = data[parentsParentsParent][parentsParent][parent][branch]
        data[parentsParentsParent][parentsParent][parent][newKey]["condition"] = condition
        delete data[parentsParentsParent][parentsParent][parent][branch]
    }
}

export function changeCondition(newCondition, data, depth, branch, parent, parentsParent, parentsParentsParent) {
    if (depth === 1) {
        data[branch]["condition"] = newCondition
    }
    if (depth === 2) {
        data[parent][branch]["condition"] = newCondition
    }
    if (depth === 3) {
        data[parentsParent][parent][branch]["condition"] = newCondition
    }
    if (depth === 4) {
        data[parentsParentsParent][parentsParent][parent][branch]["condition"] = newCondition
    }
}

export function getUserInfo(userData, annieuser) {
    const user = userData.find(user => user?.id === annieuser);

    if (!user) {
        return {
            initials: "UK",
            name: "Unknown",
            role: "",
            email: "",
            meta: {}
        };
    }

    const meta = user?.meta || {};
    const firstname = meta.firstname || "";
    const lastname = meta.lastname || "";

    // Generate initials from firstname and lastname if available
    const initials = firstname && lastname
        ? `${firstname[0]}${lastname[0]}`.toUpperCase()
        : "UK";

    // Combine firstname and lastname for full name
    const name = firstname && lastname
        ? `${firstname} ${lastname}`
        : "Unknown";

    // Get role and email from meta object with fallbacks
    const role = meta?.role || "";
    const email = meta?.email || "";

    return {
        initials,
        name,
        role,
        email,
        meta
    };
}

export function getAnnieUserWithId(userData, annieuser) {
    const user = userData.filter(e => e?.id === annieuser)?.[0]
    if (user) {
        return user
    } else {
        return annieuser
    }
}

export function getNameWithAnnieUser(userData, annieuser) {
    const user = userData.filter(e => e.id === annieuser)[0]
    if (!user || !user.meta) {
        return annieuser
    }
    if (user.meta.firstname && user.meta.lastname) {
        return user.meta.firstname + " " + user.meta.lastname
    }
    return annieuser
}

export function getStudentFromContacts(studentId, contactsData) {
    return contactsData.some(contact => contact?.id === studentId) ?
        contactsData.find(contact => contact?.id === studentId) :
        null
}

export function getStudentName(student, intl) {
    return !student ?
        intl.formatMessage(
            {
                id: 'survey.contacts.unknownRecipient',
                defaultMessage: 'Unknown Contact',
            }) :
        student?.meta?.firstname && student?.meta?.lastname ?
            student.meta?.firstname + " " + student?.meta?.lastname :
            student.meta?.phonenumber
}

export function getUsersForCategory(userSurveyData, category) {
    let supportProviders = []
    for (let i = 0; i < userSurveyData.length; i++) {
        if (userSurveyData[i]?.meta.hasOwnProperty("category") && userSurveyData[i]?.meta?.category.hasOwnProperty(category) && userSurveyData[i]?.meta?.category[category]) {
            supportProviders.push(userSurveyData[i].annieuser)
        }
    }
    return supportProviders
}

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window
    return {
        width,
        height
    }
}

export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions())
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, []);

    return windowDimensions;
}

export function getAnnieuserForContactWithRole(id, role, data) {
    const obj = data.filter(obj => obj?.role === role && obj?.contact === id)
    return obj.map(user => user?.annieuser).join(", ")
}

export function getFollowUpOptions(followUpConfigData) {
    const lowerCaseConfigFiles = followUpConfigData.hasOwnProperty("files") ? Object.keys(followUpConfigData.files).map(file => file.toLowerCase()) : []
    const followUpOptions = (followUpConfigData.hasOwnProperty("config") && followUpConfigData.hasOwnProperty("files")) ?
        followUpConfigData.config.filter(config => lowerCaseConfigFiles.includes(config.toLowerCase())) :
        []
    return followUpOptions
}

function moveResponseKeyToParent(config) {
    function consolidateResponse(node) {
        let childResponse = null

        // Check each child for a response key and consolidate it to the parent
        Object.keys(node).forEach(key => {
            if (typeof node[key] === 'object' && node[key] !== null && !Array.isArray(node[key])) {
                if (node[key].response !== undefined) {
                    childResponse = node[key].response
                    delete node[key].response
                }
                consolidateResponse(node[key])
            }
        })

        if (childResponse !== null) {
            node.response = childResponse
        }
    }

    consolidateResponse(config)
}

export function flattenConfigObject(obj) {
    const objCopy = _.cloneDeep(obj)
    const flattened = { ...objCopy };
    moveResponseKeyToParent(flattened.config)
    flattened.config = flattenSurveyObject(objCopy.config);
    return flattened;
}

export function flattenSurveyObject(obj, parent = null, flattened = {}, uniqueIds = {}) {
    const skipKeys = ['title', 'reminders', 'campaign', 'supportBots', 'useCustomInstructions', 'customInstructions']
    for (const key in obj) {
        if (parent === null && key === 'message') {
            flattened[key] = obj[key]

        } else if (skipKeys.includes(key)) {
            flattened[key] = obj[key]
        } else if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
            let newKey = key;
            if (uniqueIds.hasOwnProperty(key)) {
                uniqueIds[key] += 1;
                newKey = key + uniqueIds[key];
            } else {
                uniqueIds[key] = 0;
            }

            const newParent = newKey;
            const childObj = { ...obj[key], parent: parent };
            flattened[newParent] = childObj;
            flattenSurveyObject(childObj, newParent, flattened, uniqueIds);
            delete obj[key];
        } else {
            if (parent) {
                if (!flattened[parent]) {
                    flattened[parent] = {};
                }
                flattened[parent][key] = obj[key];
            } else {
                flattened[key] = obj[key];
            }
        }
    }

    return flattened;
}

function moveResponseKeyToDescendants(config) {
    function distributeResponse(node) {
        if (node?.response?.length > 0) {
            // Temporarily store the parent's response
            let parentResponse = node.response
            delete node.response  // Remove the response from the current node

            // Process each child first to handle existing 'response' keys deeper in the structure
            Object.keys(node).forEach(key => {
                if (typeof node[key] === 'object' && node[key] !== null && !Array.isArray(node[key])) {
                    distributeResponse(node[key])  // Recursive call to handle deeper structures first
                }
            })

            // Now distribute the parent's response to children
            Object.keys(node).forEach(key => {
                if (typeof node[key] === 'object' && node[key] !== null && !Array.isArray(node[key])) {
                    // Only assign parentResponse if child doesn't already have a 'response' moved deeper
                    if (node[key].response === undefined) {
                        node[key].response = parentResponse
                    }
                }
            })
        } else {
            // If no response at this level, just process all children
            Object.keys(node).forEach(key => {
                if (typeof node[key] === 'object' && node[key] !== null && !Array.isArray(node[key])) {
                    distributeResponse(node[key])
                }
            })
        }
    }

    distributeResponse(config)
}


export function reconstructConfigObject(flattened) {
    const reconstructed = { ...flattened }
    reconstructed.config = reconstructObject(flattened.config)
    moveResponseKeyToDescendants(reconstructed.config)
    return reconstructed
}

export function reconstructObject(flattened) {
    const reconstructed = {};
    const skipKeys = ['title', 'message', 'reminders', 'campaign', 'supportBots', 'useCustomInstructions', 'customInstructions']

    function findParentObject(obj, parentKey) {
        if (obj.hasOwnProperty(parentKey)) {
            return obj[parentKey];
        }
        for (const key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                const found = findParentObject(obj[key], parentKey);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    }

    for (const key in flattened) {
        const entry = flattened[key];
        const parentKey = entry.parent;
        const newKey = key.startsWith("other") ? "other" : key;

        if (skipKeys.includes(newKey)) {
            if(Array.isArray(entry)) {
                reconstructed[newKey] = [...entry];
            } else {
                reconstructed[newKey] = entry;
            }
        } else {
            if (parentKey) {
                const parentObject = findParentObject(reconstructed, parentKey);
                if (parentObject) {
                    parentObject[newKey] = typeof entry === 'object' ? {...entry} : entry;
                    if (typeof parentObject[newKey] === 'object') {
                        delete parentObject[newKey].parent;
                    }
                } else {
                    reconstructed[newKey] = typeof entry === 'object' ? {...entry} : entry;
                    if (typeof reconstructed[newKey] === 'object') {
                        delete reconstructed[newKey].parent;
                    }
                }
            } else {
                reconstructed[newKey] = typeof entry === 'object' ? {...entry} : entry;
                if (typeof reconstructed[newKey] === 'object') {
                    delete reconstructed[newKey].parent;
                }
            }
        }
    }

    return reconstructed;
}

export function compareDateStrings(dateString1, dateString2) {
    if (!dateString1 || !dateString2 ) {
        return 0
    }
    const date1 = new Date(dateString1);
    const date2 = new Date(dateString2);

    if (date1 > date2) {
        return 1; // dateString1 is greater (more recent) than dateString2
    } else if (date1 < date2) {
        return -1; // dateString1 is less (older) than dateString2
    } else {
        return 0; // dateString1 and dateString2 are equal
    }
}

export function getBranchFromCondition(condition) {
    let conditionMatch = condition
    if (!condition) {
        return null
    }
    if (condition.includes("[")) {
        // Remove the other uppercase character before ], and characters [ & ]
        const newCondition = condition.replace(/(.(?=[\]]))|([\[])|([\]])/gm, "")
        conditionMatch = newCondition
    }
    const match = conditionMatch.match(/^\^([\wäöåÄÖÅ]+)/) // condition.match(/\^([^\b]+)\\b/)
    return match ? match[1] : null
}

export function getNewCategoryKey(categories) {
    let maxNumber = 0

    for (const key in categories) {
        if (key.startsWith('CA')) {
            const numberPart = parseInt(key.slice(2), 10)
            if (numberPart > maxNumber) {
                maxNumber = numberPart
            }
        }
    }

    const nextNumber = maxNumber + 1
    const nextKey = 'CA' + nextNumber

    return nextKey
}

export function getNewTopicKey(topics) {
    let maxNumber = 0

    for (const key in topics) {
        if (key.startsWith('TOPIC')) {
            const numberPart = parseInt(key.slice(5), 10);

            // Update maxNumber if the current number is greater
            if (!isNaN(numberPart) && numberPart > maxNumber) {
                maxNumber = numberPart
            }
        }
    }

    const nextNumber = maxNumber + 1;

    let nextKey
    if (nextNumber < 10) {
        nextKey = 'TOPIC00' + nextNumber
    } else if (nextNumber < 100) {
        nextKey = 'TOPIC0' + nextNumber
    } else {
        nextKey = 'TOPIC' + nextNumber
    }

    return nextKey;
}

export function isCategoryUsedMoreThanOnce(category, config) {
    const categoryCount = {};

    for (const key in config) {
        if (typeof config[key] === 'object' && config[key] !== null && config[key].hasOwnProperty('category')) {
            categoryCount[config[key].category] = (categoryCount[config[key].category] || 0) + 1;
        }
    }

    return categoryCount[category] > 1;
}

export function getCategories(config) {
    let categories = new Set()

    function extractCategories(obj) {
        for (let key in obj) {
            if (typeof obj[key] === "object" && obj[key] !== null) {
                extractCategories(obj[key])
            } else if (key === "category") {
                categories.add(obj[key])
            }
        }
    }

    extractCategories(config)

    return [...categories]
}

export function findUserById(id, users) {
    const user = users.find(user => user.id === id)
    if (!user) {
        return `No user found with id ${id}`
    }

    if (user?.meta && (user.meta?.firstname || user.meta?.lastname || user.meta?.userid || user.meta?.email)) {
        const { firstname = '', lastname = '', userid = '', email = '' } = user.meta
        const identification = userid ? userid : email ? email : ''

        if (firstname || lastname) {
            return `${firstname} ${lastname}${identification ? ' - ' + identification : ''}`
        } else {
            return identification || id
        }
    } else {
        return id
    }
}

export function removeCategoryKeyFromUserSurveyData(data, category) {
    return data.map(item => {
        if (item?.meta?.category?.[category]) {
            let newItem = { ...item, meta: { ...item.meta, category: { ...item.meta.category } } }
            delete newItem.meta.category[category]
            return newItem
        } else {
            return item
        }
    })
}

export function deleteKeyAndChildren(obj, keyToDelete) {
    // Save parent value of the deleted key
    let parentOfDeletedKey = obj[keyToDelete] ? obj[keyToDelete].parent : null

    // delete the key
    delete obj[keyToDelete]

    // Array to track keys with the same parent
    let siblingKeys = []

    // loop through the object
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            // Check for keys with the same parent value
            if (obj[key].parent === parentOfDeletedKey) {
                siblingKeys.push(key)
            }
            if (obj[key].hasOwnProperty('parent') && obj[key].parent === keyToDelete) {
                // recursively call deleteKeyAndChildren for the current key
                deleteKeyAndChildren(obj, key)
            }
        }
    }

    // Delete the other key when sibling keys have been deleted
    if (siblingKeys.length === 1 && siblingKeys[0].startsWith('other')) {
        delete obj[siblingKeys[0]]
    }
}

export function getNextBranchCondition(config, parentKey) {
    let siblingConditions;
    let nextKey;
    let parentCondition

    if(parentKey !== null){
        siblingConditions = Object.keys(config)
            .filter(key => key.startsWith('branch') && config[key].parent === parentKey)
            .map(key => config[key].condition.slice(1, -2))

        parentCondition = config[parentKey]?.condition.slice(1, -2)
    } else {
        siblingConditions = Object.keys(config)
            .filter(key => key.startsWith('branch') && config[key].parent === null)
            .map(key => config[key].condition.slice(1, -2))
    }

    if (siblingConditions.length === 0) {
        if (parentKey !== null && /[a-zA-Z]\d+$/.test(parentCondition)) { // if parentKey ends with a letter followed by a number
            nextKey = `${parentCondition}1`;
        } else {
            nextKey = 'A';
        }
    } else {
        const lastSibling = siblingConditions[siblingConditions.length - 1];

        if (/\d+$/.test(lastSibling)) { // check if it ends with a number
            let baseKey = lastSibling.match(/(.*?)(\d+)$/)[1]; // extract the base key without number
            let lastNumber = Number(lastSibling.match(/(.*?)(\d+)$/)[2]); // extract the last number
            nextKey = `${baseKey}${lastNumber + 1}`;
        } else if (/[a-zA-Z]$/.test(lastSibling)) { // check if it ends with a letter
            let baseKey = lastSibling.slice(0, -1); // extract the base key without last character
            let lastChar = lastSibling.slice(-1); // extract the last character
            let nextChar = String.fromCharCode(lastChar.charCodeAt(0) + 1);
            nextKey = `${baseKey}${nextChar}`;
        }
    }

    return nextKey
}

export function generateNewBranchKey(obj) {
    let i = 1
    while(obj.hasOwnProperty(`branch${i}`)) {
        i++
    }
    return `branch${i}`
}

export function generateNewOtherKey(obj) {
    let i = 1
    while(obj.hasOwnProperty(`other${i}`)) {
        i++
    }
    return `other${i}`
}

export function checkIfParent(obj, branchKey) {
    for (let key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            if (obj[key].parent === branchKey) {
                return true;
            } else {
                if (checkIfParent(obj[key], branchKey)) {
                    return true;
                }
            }
        }
    }
    return false;
}

export function logSessionStorage() {
    for (let i = 0; i < sessionStorage.length; i++) {
        let key = sessionStorage.key(i);
        let value = sessionStorage.getItem(key);
        console.log(`${key}`);
    }
}
export const clearValueFromSessionStorage = (key, surveyId) => {
    const shouldIncludeSurveyId = key === 'surveyData' || key === 'userSurveyData';
    const storageKey = shouldIncludeSurveyId && surveyId ? `${key}_${surveyId}` : key;
    sessionStorage.removeItem(storageKey);
}

export function hasReplyAsChild(dataObject, parentKey){
    for (let key in dataObject) {
        if (typeof dataObject[key] === 'object' && dataObject[key] !== null) {
            // If the parent key matches the given key and the condition is '.*', return true
            if (dataObject[key].parent === parentKey && dataObject[key].condition === ".*") {
                return true;
            }
        }
    }
    // If no match is found in the entire data object, return false
    return false;
}

export function extractContactHeaders(data) {
    let contactHeaders = new Set()
    for (let i = 0; i < data.length; i++) {
        for (const key of Object.keys(data[i])) {
            contactHeaders.add(key)
        }
    }
    return Array.from(contactHeaders)
}

// Use a recursive function when updating nested objects
function applyRecursiveUpdates(obj, callback) {
    if (!obj || typeof obj !== 'object') return

    for (let key in obj) {
        if (obj[key] && typeof obj[key] === 'object') {
            callback(obj[key])
            applyRecursiveUpdates(obj[key], callback)
        }
    }
}

export function setNoFollowUpTypesToNull(data) {
    if (!data || !data.hasOwnProperty("config")) return data

    let updatedData = _.cloneDeep(data)

    applyRecursiveUpdates(updatedData.config, item => {
        if (item?.supportneed === true) {
            if (!item.hasOwnProperty('followuptype') || item.followuptype === 'NOFOLLOWUP') {
                item.followuptype = null
            }
        }
    })

    return updatedData
}

export function sanitizeCondition(data) {
    if (!data || !data.hasOwnProperty("config")) return data

    // Clone the data
    let updatedData = _.cloneDeep(data)

    applyRecursiveUpdates(updatedData.config, item => {
        if (item?.supportneed === true && item.condition && item.condition.includes("[")) {
            // Remove the other uppercase character before ], and characters [ & ]
            item.condition = item.condition.replace(/.(?=\])|\[|\]/g, "")
        }
    })

    return updatedData
}

export function setSupportTypeIfAbsent(data) {
    if (!data || !data.hasOwnProperty("config")) return data

    let updatedData = _.cloneDeep(data)

    applyRecursiveUpdates(updatedData.config, item => {
        if (item?.supportneed === true && !item.hasOwnProperty("supporttype")) {
            item.supporttype = "SUPPORTPROVIDER"
        }
    })

    return updatedData
}

export function removeUnnecessaryKeys(data) {
    if (!data || !data.hasOwnProperty("config")) return data

    let updatedData = _.cloneDeep(data)

    applyRecursiveUpdates(updatedData.config, item => {
        if (!item.hasOwnProperty('supportneed') || item?.supportneed !== true) {
            delete item.followuptype
            delete item.supporttype
            delete item.category
        }
    })

    return updatedData
}

export function changeSupportTypesToProvider(survey) {
    Object.keys(survey.config).forEach(key => {
        const item = survey.config[key]
        if (item && typeof item === 'object' && item.supportneed) {
            item.supporttype = "SUPPORTPROVIDER"
            if (!item.category) {
                item.category = "Z"
            }
        }
    })
    return survey
}

export function filterTopicsFromCategories(data) {
    const topicsOnly = {}

    Object.keys(data).forEach(key => {
        if (key.startsWith("TOPIC")) {
            topicsOnly[key] = data[key]
        }
    })

    return topicsOnly
}